import { AnnotationPlugin } from '@st/document-viewer-kit'
import { TextAnnotation } from '@st/sdk/src/sdk.types'
import { TextToolState } from '~/st-doc-viewer/annotations'
import { copyToolState, TEXT_COLOR_OPTIONS, TextAnnotationElement, TextToolOverlay } from './ui'

export { TextToolEditor } from './ui'

export function textToolPlugin(): AnnotationPlugin<TextAnnotation, TextToolState> {
  return {
    name: 'text',
    initialToolState: {
      name: 'text',
      settings: {
        color: TEXT_COLOR_OPTIONS[0],
        font: { family: 'Helvetica', size: 24, weight: 'normal' }
      }
    },
    ToolOverlay: TextToolOverlay,
    Element: TextAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'text',
    onAnnotationSelected: (event, send) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        send({ type: 'updateTool', tool: copyToolState(annotation) })
      }
    },
    onAnnotationDeselected: (event, send) => {
      if (event.annotationDraft && event.annotationDraft.content == '') {
        if (event.annotation) {
          // we need to delete it since it exists on the server
          send({ type: 'deleteAnnotation', annotationId: event.annotation.id })
        } else {
          // we just need to discard the draft since it doesn't exist on the server
          send({ type: 'discardAnnotationDraft', annotationId: event.annotationDraft.id })
        }
        return
      }

      if (!event.annotation && event.annotationDraft) {
        send({ type: 'createAnnotation', annotationDraft: event.annotationDraft })
      } else if (event.annotation && event.annotationDraft) {
        send({ type: 'updateAnnotation', annotationDraft: event.annotationDraft })
      }
    }
  }
}
